<div class="my-work">
  <action-title-header
    [title]="'MyWork.title' | translate"
    [buttonText]="'MyWork.newTask' | translate"
    (onAction)="createNewTask()"
    [stickyWithSideNavigation]="true"
  >
    <list-search />
    <div class="work-list__tabs">
      <button-group-v2 [config]="buttonGroupConfig" (onClick)="onTabClick($event)" class="w-100 w-sm-auto" />
    </div>
    <list-filters-btn-v2 [filters]="MyWorkFiltersComponent" />
  </action-title-header>

  <div class="my-work__content">
    <div class="my-work__content__tasks">
      <app-list-chips-active-filters [component]="MyWorkFiltersComponent" />

      <ng-select
        [ngStyle]="{ display: 'none' }"
        #selectTab
        ngSelectExtension
        class="select select-default my-work__content__select-tabs"
        [dropdownPosition]="'bottom'"
        [items]="tabs"
        [clearable]="false"
        [searchable]="false"
        [bindLabel]="'text'"
        [bindValue]="'id'"
        [placeholder]="'Projects.tabs' | translate"
        (change)="onTabClick($event)"
        [tabIndex]="-1"
      />

      <div class="my-work__tasks-section">
        <div class="my-work__tasks-section-header">
          <h4 class="my-work__tasks-title">{{ 'Projects.projectTasks' | translate }}</h4>
          <app-button
            *ngIf="!delegatedTasksMode()"
            (onClick)="createMyWorkTaskGroup('project')"
            [config]="{
              size: ButtonSize.SMALL,
              type: ButtonTypes.NEW_SECONDARY_BLUE,
              text: ('Projects.newGroup' | translate),
              prependSrc: './assets/img/ic-plus.svg'
            }"
          />
        </div>

        @if (initialLoading()) {
          <div class="d-flex align-items-center justify-content-center my-5">
            <div class="lds-dual-ring"></div>
          </div>
        } @else {
          <list-tasks
            [groups]="projectGroups()"
            [loading]="loading()"
            (taskDropped)="onTaskDrop($event)"
            (taskStatusChanged)="onTaskStatusChanged($event)"
            (groupEditRequested)="onGroupEditRequested($event)"
            (groupOrderChanged)="onProjectGroupOrderChanged($event)"
            (addTask)="onAddTaskToGroup($event)"
          />
        }
      </div>

      <div class="my-work__tasks-section mt-3 mb-4">
        <div class="my-work__tasks-section-header">
          <h4 class="my-work__tasks-title">{{ 'Projects.withoutProjectTasks' | translate }}</h4>
          <app-button
            *ngIf="!delegatedTasksMode()"
            (onClick)="createMyWorkTaskGroup('without_project')"
            [config]="{
              size: ButtonSize.SMALL,
              type: ButtonTypes.NEW_SECONDARY_BLUE,
              text: ('Projects.newGroup' | translate),
              prependSrc: './assets/img/ic-plus.svg'
            }"
          />
        </div>

        @if (initialLoading()) {
          <div class="d-flex align-items-center justify-content-center my-5">
            <div class="lds-dual-ring"></div>
          </div>
        } @else {
          <list-tasks
            [groups]="withoutProjectGroups()"
            [loading]="loading()"
            (taskDropped)="onTaskDrop($event)"
            (taskStatusChanged)="onTaskStatusChanged($event)"
            (groupEditRequested)="onGroupEditRequested($event)"
            (groupOrderChanged)="onWithoutProjectGroupOrderChanged($event)"
            (addTask)="onAddTaskToGroup($event)"
          />
        }
      </div>
    </div>
  </div>
</div>
